import L_HTML5 from "../../assets/img/skills/html-5.svg";
import L_CSS3 from "../../assets/img/skills/css3.svg";
import L_BOOTSTRAP from "../../assets/img/skills/bootstrap-4.svg";
import L_REACT from "../../assets/img/skills/react.svg";
import L_REDUX from "../../assets/img/skills/redux.svg";
import L_REDUX_TOOLKIT from "../../assets/img/skills/redux-toolkit.svg";
import L_STYLED_COMPONENTS from "../../assets/img/skills/styled-components.svg";
import L_MATERIAL_UI from "../../assets/img/skills/material-ui-1.svg";
import L_CHAKRA_UI from "../../assets/img/skills/chakra-ui-icon.svg";
import L_NODE_JS from "../../assets/img/skills/nodejs.svg";
import L_EXPRESS from "../../assets/img/skills/express.svg";
import L_MONGODB from "../../assets/img/skills/mongodb.svg";
import L_REDIS from "../../assets/img/skills/redis.svg";
import L_NEXT_JS from "../../assets/img/skills/next-js.svg";
import L_SOCKET_IO from "../../assets/img/skills/socket-io-svgrepo-com.svg";
import L_FIREBASE from "../../assets/img/skills/firebase.svg";
import L_CLOUDINARY from "../../assets/img/skills/cloudinary.png";
import L_GIT from "../../assets/img/skills/git-icon.svg";
import L_GITHUB from "../../assets/img/skills/github.svg";
import L_JAVASCRIPT from "../../assets/img/skills/javascript.svg";
import L_TYPESCRIPT from "../../assets/img/skills/typescript.svg";
import L_TAILWIND from "../../assets/img/skills/tailwindcss.svg";
import L_BULLMQ from "../../assets/img/skills/bullmq.svg";
import L_SQL from "../../assets/img/skills/sql.svg";
import L_WEBSOCKETS from "../../assets/img/skills/websockets.svg";
import L_STRIPE from "../../assets/img/skills/stripe.svg";
import L_DOCKER from "../../assets/img/skills/docker.svg";
import L_MONGOOSE from "../../assets/img/skills/mongoose.svg";
import L_REST_API from "../../assets/img/skills/rest-api.svg";
import L_MICROSERVICES from "../../assets/img/skills/microservices.svg";
import L_TUYA from "../../assets/img/skills/tuya.svg";
import L_WEBHOOKS from "../../assets/img/skills/webhooks.svg";
import L_EVENT_DRIVEN from "../../assets/img/skills/event-driven.svg";
import L_CICD from "../../assets/img/skills/cicd.svg";
import L_GITLAB from "../../assets/img/skills/gitlab.svg";
import L_POSTMAN from "../../assets/img/skills/postman.svg";
import L_AGILE_SCRUM from "../../assets/img/skills/agile-scrum.svg";
import L_SYSTEM_DESIGN from "../../assets/img/skills/system-design.svg";
import L_GENERIC_TECH from "../../assets/img/skills/generic-tech-icon.svg";
import L_NETLIFY from "../../assets/img/skills/Netlify.jpg";
import L_VERCEL from "../../assets/img/skills/vercel.svg";
import L_AWS from "../../assets/img/skills/Amazon_Web_Services_Logo.svg.png";
import L_PYTHON from "../../assets/img/skills/python.svg";
import L_PHP from "../../assets/img/skills/php.svg";
import L_LARAVEL from "../../assets/img/skills/laravel.svg";

const skill = (skillName, imgSrc, link) => ({ skillName, imgSrc, link, imgAltText: skillName });

export const skills = {
  frontend: [
    skill("React JS", L_REACT, "https://react.dev/"),
    skill("Next.js", L_NEXT_JS, "https://nextjs.org/"),
    skill("Redux Toolkit", L_REDUX_TOOLKIT, "https://redux-toolkit.js.org/"),
    skill("Redux", L_REDUX, "https://redux.js.org/"),
    skill("Tailwind CSS", L_TAILWIND, "https://tailwindcss.com/"),
    skill("Material UI", L_MATERIAL_UI, "https://mui.com/"),
    skill("Chakra UI", L_CHAKRA_UI, "https://chakra-ui.com/"),
    skill("styled-components", L_STYLED_COMPONENTS, "https://styled-components.com/"),
    skill("HTML5", L_HTML5, "https://developer.mozilla.org/en-US/docs/Web/HTML"),
    skill("CSS3", L_CSS3, "https://developer.mozilla.org/en-US/docs/Web/CSS"),
    skill("Bootstrap", L_BOOTSTRAP, "https://getbootstrap.com/"),
  ],

  backend: [
    skill("Node.js", L_NODE_JS, "https://nodejs.org/en/"),
    skill("Express", L_EXPRESS, "https://expressjs.com/"),
    skill("MongoDB", L_MONGODB, "https://www.mongodb.com/"),
    skill("Mongoose", L_MONGOOSE, "https://mongoosejs.com/"),
    skill("Redis", L_REDIS, "https://redis.io/"),
    skill("BullMQ", L_BULLMQ, "https://docs.bullmq.io/"),
    skill("SQL", L_SQL, "https://en.wikipedia.org/wiki/SQL"),
    skill("REST API Design", L_REST_API, "https://restfulapi.net/"),
    skill("Microservices", L_MICROSERVICES, "https://microservices.io/"),
  ],

  cloudDeployment: [
    skill("AWS (EC2, S3)", L_AWS, "https://aws.amazon.com/"),
    skill("Docker", L_DOCKER, "https://www.docker.com/"),
    skill("Vercel", L_VERCEL, "https://vercel.com/"),
    skill("Netlify", L_NETLIFY, "https://www.netlify.com/"),
    skill("GitHub", L_GITHUB, "https://github.com/"),
  ],

  realTime: [
    skill("Socket.IO", L_SOCKET_IO, "https://socket.io/"),
    skill("WebSockets", L_WEBSOCKETS, "https://developer.mozilla.org/en-US/docs/Web/API/WebSockets_API"),
    skill("Firebase", L_FIREBASE, "https://firebase.google.com/"),
    skill("Cloudinary", L_CLOUDINARY, "https://cloudinary.com/"),
    skill("Stripe", L_STRIPE, "https://stripe.com/"),
    skill("Tuya APIs", L_TUYA, "https://developer.tuya.com/"),
    skill("Webhooks", L_WEBHOOKS, "https://en.wikipedia.org/wiki/Webhook"),
    skill("Event-driven Architecture", L_EVENT_DRIVEN, "https://en.wikipedia.org/wiki/Event-driven_programming"),
  ],

  programmingLanguages: [
    skill("JavaScript (ES6+)", L_JAVASCRIPT, "https://developer.mozilla.org/en-US/docs/Web/JavaScript"),
    skill("TypeScript", L_TYPESCRIPT, "https://www.typescriptlang.org/"),
  ],

  devOps: [
    skill("Git", L_GIT, "https://git-scm.com/"),
    skill("CI/CD", L_CICD, "https://en.wikipedia.org/wiki/CI/CD"),
    skill("GitLab", L_GITLAB, "https://about.gitlab.com/"),
    skill("Postman", L_POSTMAN, "https://www.postman.com/"),
    skill("Agile/Scrum", L_AGILE_SCRUM, "https://www.scrum.org/resources/what-is-scrum"),
    skill("System Design", L_SYSTEM_DESIGN, "https://en.wikipedia.org/wiki/Systems_design"),
    skill("GenAI Tools (Cursor, Claude)", L_GENERIC_TECH, "https://en.wikipedia.org/wiki/Generative_artificial_intelligence"),
  ],

  alsoWorkingWith: [
    skill("Python", L_PYTHON, "https://www.python.org/"),
    skill("PHP", L_PHP, "https://www.php.net/"),
    skill("Laravel", L_LARAVEL, "https://laravel.com/"),
  ],
};
